import { render, staticRenderFns } from "./cards-reports.vue?vue&type=template&id=6de2236a"
import script from "./cards-reports.vue?vue&type=script&lang=js"
export * from "./cards-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports